import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { getWatchlistWikifolioQueryKey } from "src/api/client/watchlist.api";
import { TNativeMessagePayloadOf } from "src/lib/native-bridge/define-native-message";
import { useNativeMessage } from "src/lib/native-bridge/hooks/use-native-message";
import { underlyingFollowNativeMessage, wikifolioWatchlistNativeMessage } from "src/lib/native-bridge/watchlist/watchlist-native-messages";
import { underlyingFollowStore } from "src/stores/uderlying-follow-store";

type TUnderlyingFollowPayload = TNativeMessagePayloadOf<typeof underlyingFollowNativeMessage>;
type TWikifolioWatchlistPayload = TNativeMessagePayloadOf<typeof wikifolioWatchlistNativeMessage>;

const applyUnderlyingFollow = ({ isin, isFollowed }: TUnderlyingFollowPayload) => {
    const isinOnPage = Object.keys(underlyingFollowStore.underlyingsFollowData).find(storedIsin => storedIsin.toUpperCase() === isin.toUpperCase());
    if (!isinOnPage) {
        return;
    }

    underlyingFollowStore.setIsFollowedUnderlying(isinOnPage, isFollowed);
};

interface IApplyWikifolioWatchlistParams {
    queryClient: QueryClient;
    payload: TWikifolioWatchlistPayload;
}

const applyWikifolioWatchlist = ({ queryClient, payload: { wikifolioId, isOnWatchlist } }: IApplyWikifolioWatchlistParams) => {
    const queryKey = getWatchlistWikifolioQueryKey(wikifolioId);
    const isWikifolioOnPage = queryClient.getQueryState(queryKey) !== undefined;
    if (!isWikifolioOnPage) {
        return;
    }

    queryClient.setQueryData(queryKey, isOnWatchlist);
};

export const useNativeWatchlistSync = () => {
    const queryClient = useQueryClient();

    useNativeMessage({ message: underlyingFollowNativeMessage, onMessage: applyUnderlyingFollow });
    useNativeMessage({ message: wikifolioWatchlistNativeMessage, onMessage: payload => applyWikifolioWatchlist({ queryClient, payload }) });
};
